<script setup>
import { defineProps, ref } from 'vue';
import axios from '@/plugins/axios'
import { useLayoutComponents } from '@/composables/layout.js'
import Modal from '@/components/modals/BaseModal.vue';
import { useToast } from '@/composables/use-toast';

const { TextInput, Checkbox } = useLayoutComponents()
const { addToast } = useToast();

const props = defineProps({
    show: {
        type: Boolean,
        required: true
    },
    listing: {
        type: Object,
        required: true
    },
    user_id: {
        type: String,
        required: true
    }
});

const message = ref('');
const isAgree = ref(false);

const save = async () => {
    if(isAgree.value) {
        const response = await axios.post('api/sales', {
            listing_id: props.listing.id,
            message: message.value,
            final_price: props.listing.price,
            currency: props.listing.currency,
            buyer_id: props.user_id
        })
        if(response.status === 200 || response.status === 201) {
            addToast('Request sent successfully', 'success');
        }
    } else {
        addToast('Please agree to the terms and conditions', 'error');
    }
};

</script>

<template>
    <Modal 
        :show="props.show" 
        :title="'Request Access to External Dataset'" 
        :closeOnClickOutside="true"
        :buttonText="'Submit Request'"
        :buttonLoadingText="'Submitting...'"
        :modalSize="'normal'"
        @save="save"
        :buttonDisabled="!isAgree"
    >
    <template #description>
        <div class="text-sm text-echoes-gray">This dataset is hosted externally. Seller will prepare and share access credentials after your purchase. Credentials are independently verified by Portex before payment is issued.</div>
    </template>
    <template #default>
        <div class="">
            <div>
                <div class="form-group pt-2">
                    <div class="form-label dark:text-white text-sm">Message (Optional)</div>
                    <TextInput 
                        isTextarea="true" 
                        :modelValue="message"
                        @update:modelValue="message = $event"
                        :placeholder="'Note if you have specific accessing requirements or want to access a subset of the dataset'" 
                        :required="true"
                    />
                </div>
                <div class="form-group pt-2 flex items-start gap-2">
                    <Checkbox v-model="isAgree" :required="true" />
                    <div class="flex flex-col">
                        <span for="confirmBid" class="text-sm font-semibold">Confirm request for {{ props.listing.name }}</span>
                        <a href="https://docs.portexai.com/portex-docs/datalab/purchase-datasets" target="_blank" class="text-xs text-white/80 hover:text-echoes-primary underline animate-ease-in-out duration-300">Learn more</a>
                    </div>
                </div>
            </div>
        </div>
    </template>
    </Modal>
</template>